// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__QXPTT","tab":"Tabs_tab__1QUVJ","tab__active":"Tabs_tab__active__eUibw"};